import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/Footer'
import ChangePasswordPage from '../views/changePassword/changePasswordPage'

const ChangePassword = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Header />
      <ChangePasswordPage />
      <Footer />
    </>
  )
}

export default ChangePassword;